import React from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import LogIn from "./app-modules/logIn/logIn";
import ConfirmOTP from "./app-modules/logIn/confirm-otp";
import "./App.css";
import Protected from "./container/protected";
import AppRoutes from "./helper/app-routes";
import "../src/custom-css/nn-kendo.scss";
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate } from "react-router";
import { Navigate } from "react-router-dom";
import Layout from "./control-components/layout/layout";
import DEVELOPMENT_CONFIG from "./helper/config";
import Dashboard from "./app-modules/dashboard/dashboard";
import DataImport from "./app-modules/data-import/data-import";
import Clinic from "./app-modules/clinic/clinic";
import ClinicDomain from "./app-modules/clinic-domain/clinic-domain";
import Regions from "./app-modules/regions/regions";
import AdminUsers from "./app-modules/admin-user/admin-user";
import APP_ROUTES from "./helper/app-routes";
import AddClinic from "./app-modules/clinic/add-clinic";
import Roles from "./app-modules/access-level-setting/roles";
import ClientSearch from "./app-modules/client-search/client-search";
import StaffSearch from "./app-modules/staff-search/staff-search";
import FileUpload from "./app-modules/file-upload/upload";
import AddStaff from "./app-modules/staff-search/add-staff";
import DocumentTemplate from "./app-modules/document-template/document-template";
import AddDocumentTemplate from "./app-modules/document-template/add-document-template";
import DocumenttemplateTagList from "./app-modules/document-template/document-template-tag/template-tag-list";
import ClinicDeatils from "./app-modules/clinic/clinic-details";
import StaffDocumentTemplate from "./app-modules/staff-document -templates/staff-document-template";
import AddStaffDocumentTemplate from "./app-modules/staff-document -templates/add-staff-document-template";
import TrainingLinks from "./app-modules/training-links/training-links";
import AddTrainingLink from "./app-modules/training-links/add-training-link";
import EobImport from "./app-modules/eob-import/eob-import";
import LOGS from "./app-modules/logs/logs";
import Announcement from "./app-modules/announcement/announcement";
import AddAnnouncement from "./app-modules/announcement/add-announcement";
import ClinicInfoIndex from "./app-modules/clinic/clinic-info/index";
import ServicesTransfer from "./app-modules/services/copy-services";
import DocumentTranspiler from "./app-modules/document-template/document-transpiler";
import SubpoenaRequestList from "./app-modules/misc/subpoena-request/subpoena-request-list";
import AddSubpoenaRequest from "./app-modules/misc/subpoena-request/add-subpoena-request";
import SmsTwilioLookup from "./app-modules/misc/sms-twilio-lookup/sms-twilio-lookup";
import BAA from "./app-modules/announcement/baa";
import ADDBaa from "./app-modules/announcement/add-baa";
import BAAHistoryDialog from "./app-modules/announcement/baa-history";
import AIDocumentTEMPLATE from "./app-modules/ai-document-template/ai-document-template";
const PrivateRoutes = () => {
  return (
    <div>
      <Layout>
        <Routes>
          <Route
            path={AppRoutes.DASHBOARD}
            element={<Protected Component={Dashboard} />}
          />
          <Route
            path={AppRoutes.CLINIC}
            element={<Protected Component={Clinic} />}
          />
          <Route
            path={AppRoutes.CLINIC_DETAILS}
            element={<Protected Component={ClinicDeatils} />}
          />
          <Route
            path={AppRoutes.ADD_CLINIC}
            element={<Protected Component={AddClinic} />}
          />
          <Route
            path={AppRoutes.STAFF_SEARCH}
            element={<Protected Component={StaffSearch} />}
          />
          <Route
            path={AppRoutes.ADD_STAFF}
            element={<Protected Component={AddStaff} />}
          />
          <Route
            path={AppRoutes.CLIENT_SEARCH}
            element={<Protected Component={ClientSearch} />}
          />
          <Route
            path={AppRoutes.CLINIC_DOMAIN}
            element={<Protected Component={ClinicDomain} />}
          />
          <Route
            path={AppRoutes.REGIONS}
            element={<Protected Component={Regions} />}
          />
          <Route
            path={AppRoutes.ACCESS_LEVEL_SETTINGS}
            element={<Protected Component={Roles} />}
          />
          <Route
            path={AppRoutes.FILE_UPLOAD}
            element={<Protected Component={FileUpload} />}
          />
          <Route
            path={AppRoutes.ADMIN_USER}
            element={<Protected Component={AdminUsers} />}
          />
          <Route
            path={AppRoutes.FILE_DOCUMENT_TEMPLATE}
            element={<Protected Component={DocumentTemplate} />}
          />
          <Route
            path={AppRoutes.ADD_DOCUMENT_TEMPLATE}
            element={<Protected Component={AddDocumentTemplate} />}
          />
          <Route
            path={AppRoutes.DOCUMENT_TEMPLATE_LABEL_LIST}
            element={<Protected Component={DocumenttemplateTagList} />}
          />
          <Route
            path={AppRoutes.DATA_IMPORT}
            element={<Protected Component={DataImport} />}
          />
          <Route
            path={AppRoutes.STAFF_DOCUMENT_TEMPLATE}
            element={<Protected Component={StaffDocumentTemplate} />}
          />
          <Route
            path={AppRoutes.ADD_STAFF_DOCUMENT_TEMPLATE}
            element={<Protected Component={AddStaffDocumentTemplate} />}
          />
          <Route
            path={AppRoutes.TRAINING_LINKS}
            element={<Protected Component={TrainingLinks} />}
          />
          <Route
            path={AppRoutes.ADD_TRAINING_LINKS}
            element={<Protected Component={AddTrainingLink} />}
          />
          <Route
            path={AppRoutes.EDIT_TRAINING_LINK}
            element={<Protected Component={AddTrainingLink} />}
          />
          <Route
            path={AppRoutes.EOB_IMPORT}
            element={<Protected Component={EobImport} />}
          />
          <Route
            path={AppRoutes.LOGS}
            element={<Protected Component={LOGS} />}
          />
          <Route
            path={AppRoutes.ANNOUNCEMENT}
            element={<Protected Component={Announcement} />}
          />
          <Route
            path={AppRoutes.ADD_ANNOUNCEMENT}
            element={<Protected Component={AddAnnouncement} />}
          />
          <Route
            path={AppRoutes.EDIT_ANNOUNCEMENT}
            element={<Protected Component={AddAnnouncement} />}
          />
          <Route
            path={AppRoutes.CLINIC_INFO}
            element={<Protected Component={ClinicInfoIndex} />}
          />
          <Route
            path={AppRoutes.COPY_SERVICES}
            element={<Protected Component={ServicesTransfer} />}
          />
          <Route
            path={AppRoutes.DOCUMENT_TRANS_COMPILER}
            element={<Protected Component={DocumentTranspiler} />}
          />
          <Route
            path={AppRoutes.AI_DOCUMENT_TEMPLATE}
            element={<Protected Component={AIDocumentTEMPLATE} />}
          />

          <Route
            path={AppRoutes.SUBPOENA_REQUEST}
            element={<Protected Component={SubpoenaRequestList} />}
          />
          <Route
            path={AppRoutes.SMS_TWILIO_LOOKUP}
            element={<Protected Component={SmsTwilioLookup} />}
          />
          <Route
            path={AppRoutes.ADD_SUBPOENA_REQUEST}
            element={<Protected Component={AddSubpoenaRequest} />}
          />
          <Route
            path={AppRoutes.BAA}
            element={<Protected Component={BAA} />}
          />
          <Route
            path={AppRoutes.ADD_BAA}
            element={<Protected Component={ADDBaa} />}
          />
          <Route
            path={AppRoutes.HISTORY_BAA}
            element={<Protected Component={BAAHistoryDialog} />}
          />
        </Routes>
      </Layout>
    </div>
  );
};

const MainApp = () => {
  const navigate = useNavigate();
  const location = useLocation();

  let token = localStorage.getItem(DEVELOPMENT_CONFIG.TOKEN);

  if (location.pathname === "/") {
    // if (token != null) {
    return <Navigate to={AppRoutes.LOGIN} />;
    // }
  }

  return (
    <div>
      {token ? (
        <PrivateRoutes />
      ) : (
        <Routes>
          <Route path={AppRoutes.LOGIN} element={<LogIn />} />
          <Route path={AppRoutes.CONFIRM_OTP} element={<ConfirmOTP />} />
        </Routes>
      )}
    </div>
  );
};

export default MainApp;
